module.exports = __webpack_public_path__ + "img/Philpott.4e6a9d77.png";